<template>
    <div id="filter_advanced">
        <div class="ui form" @keypress.enter="$parent.$parent.staffs_filter()">
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.username') }}</label>
                    <input type="text"
                        v-model="filter.columns.username"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.name') }}</label>
                    <input type="text"
                        v-model="filter.columns.name"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.is_banned') }}</label>
                    <div class="ui checkbox" v-checkbox>
                        <input type="checkbox" v-model="filter.columns.is_banned">
                        <label>{{ $t('ui.general.yes') }}</label>
                    </div>
                </div>
            </div>
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.role_identity') }}</label>
                    <div class="ui selection fluid dropdown" v-dropdown>
                        <div class="text"
                            v-for="role in roles"
                            v-if="filter.columns.role_identity == role.identity">
                            {{ role.name }}
                        </div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div
                                v-for="role in roles"
                                @click="filter.columns.role_identity = role.identity"
                                class="item"
                                :class="{
                                    'selected active': filter.columns.role_identity == role.identity
                                }">
                                {{ role.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field">
                    <label>{{ $t('models.attributes.staffs.station_identity') }}</label>
                    <div class="ui selection fluid dropdown" v-dropdown>
                        <div class="text"
                            v-for="station in stations"
                            v-if="filter.columns.station_identity == station.identity">
                            {{ station.name }}
                        </div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div
                                v-for="station in stations"
                                @click="filter.columns.station_identity = station.identity"
                                class="item"
                                :class="{
                                    'selected active': filter.columns.station_identity == station.identity
                                }">
                                {{ station.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field">
                    <label>{{ $t('models.attributes.staffs.theme_name') }}</label>
                    <div class="ui selection fluid dropdown" v-dropdown>
                        <div class="text"
                            v-for="theme_name in theme_names"
                            v-if="filter.columns.theme_name == theme_name">
                            <span v-if="theme_name">
                                {{ $t('ui.theme_names.' + theme_name) }}
                            </span>
                            <span v-else>
                                {{ $t('ui.general.please_select') }}
                            </span>
                        </div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div
                                v-for="theme_name in theme_names"
                                @click="filter.columns.theme_name = theme_name"
                                class="item"
                                :class="{
                                    'selected active': filter.columns.theme_name == theme_name
                                }">
                                <span v-if="theme_name">
                                    {{ $t('ui.theme_names.' + theme_name) }}
                                </span>
                                <span v-else>
                                    {{ $t('ui.general.please_select') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div
            class="ui icon blue button right floated"
            @click="$parent.$parent.staffs_filter()">
            <i class="search icon"></i>
            {{ $t('ui.general.search') }}
        </div>
        <div class="clear">

        </div>
    </div>
</template>

<script>

export default {
    name: "StaffsFilterAdvanced",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.staffs_module
        },
        filter() {
            return this.current_store.filter
        },
        theme_names() {
            return [null].concat(this.$store.state.provider.theme_menu_keys)
        },
        roles() {
            return [{
                name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.staffs_module.roles)
        },
        stations() {
            return [{
                name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.stations)
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>

<style>
.el-date-editor.el-range-editor input {
    border: none !important;
}
</style>
<style scoped lang="scss">

</style>
